export default __webpack_public_path__ + "static/media/be-efficient.fbe1e25f.svg";